<script lang="ts" setup>
import { computed } from '#imports';

const model = defineModel('open', {
  type: Boolean,
  default: false,
});
const emit = defineEmits(['ok', 'cancel']);
const props = defineProps({
  autoClose: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  content: {
    type: String,
    default: '',
  },
  cancelText: {
    type: String,
    default: '',
  },
  okText: {
    type: String,
    default: '',
  },
});
const handleOk = () => {
  if (props.autoClose) {
    model.value = false;
  }
  emit('ok');
};
const handleCancel = () => {
  if (props.autoClose) {
    model.value = false;
  }
  emit('cancel');
};
</script>

<template>
  <a-modal
    v-model:open="model"
    :centered="true"
    :closable="false"
    wrap-class-name=""
    :width="304"
    :footer="null"
    :mask-closable="false"
  >
    <div class="text-center">
      <h2 class="text-colorText mb-6 pt-2 text-base font-bold">
        {{ title }}
      </h2>
      <p class="text-colorTextSecondary text-xs">{{ content }}</p>
      <div
        class="mx-auto mt-6 flex w-[200px] items-center justify-center gap-6"
      >
        <a-button
          v-if="cancelText"
          class="button !border-[#D9D9D9]"
          type="default"
          @click="handleCancel"
        >
          <span class="text-colorText">{{ cancelText }}</span>
        </a-button>
        <a-button
          v-if="okText"
          class="button border-transparent"
          type="primary"
          @click="handleOk"
        >
          <span class="text-white">{{ okText }}</span>
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<style scoped>
.button {
  @apply flex h-[32px] max-w-[88px] flex-1 cursor-pointer items-center justify-center  rounded text-xs  font-bold hover:opacity-80;
}
</style>
